module.exports = __webpack_public_path__ + "static/media/Fr-BANZEMA_Landing_page.3c65c3d0.webp";